import { pgTable, uuid, text, integer, timestamp, index } from "drizzle-orm/pg-core";

export const searchQueries = pgTable(
  "search_queries",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    sessionId: uuid("session_id"),
    storefrontSource: text("storefront_source").notNull().default("lv"),
    query: text("query").notNull(),
    queryNormalized: text("query_normalized").notNull(),
    resultsCount: integer("results_count").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    createdIdx: index("idx_search_queries_created").on(t.createdAt),
    normalizedCreatedIdx: index("idx_search_queries_normalized_created").on(
      t.queryNormalized,
      t.createdAt,
    ),
  }),
);

export type SearchQuery = typeof searchQueries.$inferSelect;
export type NewSearchQuery = typeof searchQueries.$inferInsert;
